/* eslint-disable */

import React from "react"
import PropTypes from 'prop-types';
import style from "./index.module.css";
//import IconPlay from './play.svg'

export default class YoutubeVideo extends React.Component {

  static propTypes = {
    initialValue: PropTypes.string
  }

  static defaultProps = {
    initialValue: ''
  }

  state = {
      showVideo: this.props.image ? false : true,
      showImage: this.props.image ? true : false,
      autoplay: this.props.autoplay ? 1 : 0
  }

  showVideo = () => {
    this.setState({
      showVideo: true,
      autoplay: 1,
      showImage: false
    })
  }

  extractYoutubeVideoID = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    if ( match && match[7].length == 11 ){
      return match[7];
    }
  }

  render() {
    var videoId = this.extractYoutubeVideoID(this.props.videoUrl);
    var autoplay = this.state.autoplay;
    var image = this.props.image ? this.props.image : false;
    return (
      <div>
        {this.state.showImage &&
        <div className={style.videoImageContainer} onClick={this.showVideo}>
          <img src={image} className={style.videoImage} />
          {/* <IconPlay className={style.videoPlayButton} /> */}
        </div>
        }
        {this.state.showVideo &&
          <div className={style.videoContainer} itemProp="video">
            <iframe width="560" height="315" src={`//www.youtube-nocookie.com/embed/${videoId}?html5=1&autoplay=${autoplay}&wmode=transparent&controls=1&modestbranding=1&rel=0&showinfo=0&autohide=1&color=white&iv_load_policy=3&theme=light&playsinline=0`} frameBorder="0" allowFullScreen></iframe>
          </div>
        }
      </div>
    )
  }
}